import React, { useEffect, useState } from 'react'
import LeftMenu from '../../AnalyticsModule/Left'
import SelectField from '../../../library/components/Select'
import { useGetRecordUnitWiseEciReportMutation, useGetStatesStatusForceWiseQuery } from '../../../services/reportsServices'
import { Validators } from '../../../library/utilities/Validator'
import { downloadExcelFile, downloadPdfFile } from '../../utilities/utils'
import pdfIcon from '../../../dashboardicon/pdfsvg.svg'
import excelIcon from '../../../dashboardicon/excel.svg'
import MultiSelectCheckBox from '../../../ui/multiSelectCheckbox/MultiSelectCheckBox'
import RunnerUpHeaderNew from '../../../ui/runnerUpHeader/RunnerUpHeaderNew'

const OfficerTypeList = [
    { value: "", label: "Select Report Type" },
    { value: "record", label: "Record Wise" },
    { value: "unit", label: "Unit Wise" }
];
const header = [
    "SNo",
    "Phase No",
    "StateName",
    "Name",
    "Record Id",
    "Mobile",
    "Email",
    "EndDate",
    "PendingCount",
]

const header2 = [
  "SNo",
  "Phase No",
  "StateName",
  "Name",
  "Record Id",
  "Unit Id",
  "Mobile",
  "Email",
  "EndDate",
  "PendingCount",
]

const phaseList = [];

const RecordUnitPendingCount = () => {
    const [reportData,datap] = useGetRecordUnitWiseEciReportMutation()
    const [tableData, setTableData] = useState([]);
    const [selected, setSelected] = useState([]);
    const [states, setStates] = useState({
        stateValue: "",
        OfficerType: "",
      });
      const [Error, setError] = useState({});

      useEffect(()=>{
        const Phases = JSON.parse(localStorage?.phaseList)
        Phases.map((item)=>{
         phaseList.push({value:item, label:item})
        })
     
       },[])

      const handleChange = (key, value) => {
        setStates((prevState) => ({
          ...prevState,
          [key]: value,
        }));
      };

      const getError = (key, value) => {
        let error = { ...Error };
        if (value && value.message) {
          setError({ ...Error, [key]: value.message });
        } else {
          delete error[key];
          setError(error);
        }
      };

      const renderTableData = (type) => {
        let error = {};
        if (!selected || selected.length === 0) {
          error["phaseList"] = "This field is required";
        }
        if (!states.OfficerType || states.OfficerType === "" || states.OfficerType.length == 0) {
          error["OfficerType"] = "This Field is required"
        }
        if (Object.keys(error).length) {
          setError(error);
          return;
        }
        const data = [];
    selected.map((item) => data.push(item.value));

        let payload = {
          "stateCd": data,
          "userType": states.OfficerType
        }
        reportData(payload)
          .unwrap()
          .then((res) => {
            let tData = []
            res?.payload?.map((item,i) => {
              states?.OfficerType==="record"?
              tData.push({
                SNo:i+1,
                PhaseNo:item?.phaseNo,
                StateName: item?.stateName,
                Name: item?.userName,
                RecordId:item?.recordId,
                // UserId: item?.userId,
                Mobile: item?.userMobile,
                Email: item?.mailId,
                EndDate: item?.endDate,
                PendingCount: item?.pendingCount,
              }): states?.OfficerType==="unit"?
              tData.push({
                SNo:i+1,
                PhaseNo:item?.phaseNo,
                StateName: item?.stateName,
                Name: item?.userName,
                RecordId:item?.recordId,
                UserId: item?.userId,
                Mobile: item?.userMobile,
                Email: item?.mailId,
                EndDate: item?.endDate,
                PendingCount: item?.pendingCount,
              }):tData=[]
            });
            setTableData(tData)
            if(type==="excel"){
              downloadExcelFile(`${states?.OfficerType==="unit"?"Unit Offier Wise e-PB Pending List ":states?.OfficerType==="record"?"Record Offier Wise e-PB Pin Pending List ":null}`,"Pending list",states?.OfficerType==="unit"?header2:header,tData)
             } 
             if(type==="pdf"){
              downloadPdfFile(`${states?.OfficerType==="unit"?"Unit Offier Wise e-PB Pending List ":states?.OfficerType==="record"?"Record Offier Wise e-PB Pin Pending List ":null}`,states?.OfficerType==="unit"?header2:header,tData)
             }
            // setTotalNoOfRecords(res?.payload?.length)
          })
          .catch((error) => {
            if(error?.data?.message==="No record found")
            {
              setTableData([])
            }
          })
      };

  return (
<LeftMenu>
<div className="container box shadow ">
      <div className="row">
          <div className="col-md-12">
         <RunnerUpHeaderNew title={"Record / Unit Pending List"}  />
          </div>
        </div>
        <div className="row">
        <div className="col-md-2" style={{paddingRight:"0px"}}><p style={{textAlign:"right",paddingTop:"6px"}}>Select Phase</p></div>
        <div className="col-md-4">
            <MultiSelectCheckBox
              options={phaseList}
              name="phaseList"
              value={selected}
              className={"col-md-12"}
              onChange={setSelected}
              labelledBy="Select"
              validators={[
                {
                  check: Validators.required,
                  message: "This field is required",
                },
              ]}
              getError={(val) => getError("phaseList", val)}
              Error={Error}
            ></MultiSelectCheckBox>
          </div>
          <SelectField
            labelClass=""
            inputClass="col-md-2 pr-1"
            name="OfficerType"
            value={states.OfficerType}
            handleChange={(val) => handleChange("OfficerType", val)}
            options={OfficerTypeList}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              }
            ]}
            getError={(val) => getError("OfficerType", val)}
            Error={Error}
          />
          <div className="col-md-2  download_button">
          <button
              type="button"
              className="btn btn-primary btn-sm searchbuttonreport"
              onClick={()=>renderTableData("pdf")}>
              Download As
              <span className="pl-2">
               <img src={pdfIcon} alt=""  style={{height:"25px",width:"25px"}}/>
              </span>
            </button>
          </div>
          <div className="col-md-2 download_button">
          <button
              type="button"
              className="btn btn-danger btn-sm searchbuttonreport"
              onClick={()=>renderTableData("excel")}>
              Download As
              <span className="pl-2">
               <img src={excelIcon} alt=""  style={{height:"25px",width:"25px"}}/>
              </span>
            </button>
          </div>
        </div>
</div>

</LeftMenu>
    )
}

export default RecordUnitPendingCount